import api from "../../services/api";

const empty = { data: { data: [] } };

/**
 * Carga datos completos para el modal/panel de vista previa de propiedad.
 */
export async function cargarDatosFichaResumen(propiedadId) {
  const [resFotos, resSuperficies, resPropietarios, resVideos, resDocumentos, resContactos] =
    await Promise.all([
      api.get(`/propiedades/${propiedadId}/fotos`),
      api.get(`/propiedades/${propiedadId}/superficies`),
      api.get(`/propiedades/${propiedadId}/propietarios`),
      api.get(`/propiedades/${propiedadId}/videos`).catch(() => empty),
      api.get(`/propiedades/${propiedadId}/documentos`).catch(() => empty),
      api.get(`/propiedades/${propiedadId}/contactos`).catch(() => empty),
    ]);

  let detalles = {};
  try {
    const resDetalle = await api.get(`/propiedades/${propiedadId}`);
    detalles = resDetalle.data.data || resDetalle.data || {};
  } catch {
    /* detalle opcional */
  }

  const propietarios = resPropietarios.data.data || [];
  const contactos_asociados = resContactos.data.data || [];

  return {
    ...detalles,
    fotos: resFotos.data.data || [],
    superficies: resSuperficies.data.data || [],
    propietarios,
    videos: resVideos.data.data || [],
    documentos: resDocumentos.data.data || [],
    contactos_asociados,
    contacto_comunicacion_id:
      detalles.contacto_comunicacion_id ||
      propietarios.find((p) => p.es_comunicacion)?.contacto_id ||
      contactos_asociados.find((c) => c.es_comunicacion)?.contacto_id ||
      null,
  };
}
